import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressBookDto } from '@cradua/data';

@Component({
  selector: 'cradua-address-book-list',
  templateUrl: './address-book-list.component.html',
  styleUrls: ['./address-book-list.component.scss']
})
export class AddressBookListComponent implements OnInit {

  @Input() addressBooks: AddressBookDto[];
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {}

  onTaskEmit() {

  }

  onView(value) {
    this.emitAddressBook.emit(value);
  }

}
